import React from 'react';
import Icon from '../../../components/AppIcon';
import { format } from 'date-fns';

const PaymentHistory = ({ paymentHistory, loading }) => {
  const getStatusColor = (status) => {
    const colors = {
      paid: 'text-success bg-success/10',
      pending: 'text-warning bg-warning/10',
      overdue: 'text-error bg-error/10',
      scheduled: 'text-primary bg-primary/10'
    };
    return colors?.[status] || 'text-muted-foreground bg-muted';
  };

  const getStatusIcon = (status) => {
    const icons = {
      paid: 'CheckCircle',
      pending: 'Clock',
      overdue: 'AlertCircle',
      scheduled: 'Calendar'
    };
    return icons?.[status] || 'Circle';
  };

  if (loading) {
    return (
      <div className="bg-card rounded-xl p-8 border text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4"></div>
        <p className="text-muted-foreground">Loading payment history...</p>
      </div>
    );
  }

  if (paymentHistory?.length === 0) {
    return (
      <div className="bg-card rounded-xl p-8 text-center border">
        <Icon name="History" size={48} className="mx-auto mb-4 text-muted-foreground" />
        <h3 className="text-lg font-semibold text-foreground mb-2">No payment history</h3>
        <p className="text-muted-foreground">Your bill payment history will appear here</p>
      </div>
    );
  }

  return (
    <div className="bg-card rounded-xl border shadow-sm overflow-hidden">
      <div className="p-4 md:p-6 border-b">
        <h2 className="text-xl font-semibold text-foreground">Payment History</h2>
        <p className="text-sm text-muted-foreground mt-1">View your past bill payments</p>
      </div>

      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="bg-muted/50">
            <tr>
              <th className="px-4 py-3 text-left text-sm font-medium text-foreground">Date</th>
              <th className="px-4 py-3 text-left text-sm font-medium text-foreground">Bill Name</th>
              <th className="px-4 py-3 text-left text-sm font-medium text-foreground">Category</th>
              <th className="px-4 py-3 text-left text-sm font-medium text-foreground">Amount</th>
              <th className="px-4 py-3 text-left text-sm font-medium text-foreground">Method</th>
              <th className="px-4 py-3 text-left text-sm font-medium text-foreground">Status</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-border">
            {paymentHistory?.map(payment => (
              <tr key={payment?.id} className="hover:bg-muted/30 transition-colors">
                <td className="px-4 py-3 text-sm text-foreground">
                  {format(new Date(payment?.payment_date), 'MMM dd, yyyy')}
                </td>
                <td className="px-4 py-3 text-sm font-medium text-foreground">
                  {payment?.recurring_bills?.bill_name || 'N/A'}
                </td>
                <td className="px-4 py-3 text-sm text-muted-foreground capitalize">
                  {payment?.recurring_bills?.category || 'N/A'}
                </td>
                <td className="px-4 py-3 text-sm font-semibold text-foreground">
                  ${payment?.amount_paid?.toFixed(2)}
                </td>
                <td className="px-4 py-3 text-sm text-muted-foreground">
                  {payment?.payment_method || 'N/A'}
                </td>
                <td className="px-4 py-3">
                  <div className={`inline-flex items-center gap-1 px-2 py-1 rounded-md text-xs font-medium ${
                    getStatusColor(payment?.status)
                  }`}>
                    <Icon name={getStatusIcon(payment?.status)} size={12} />
                    <span className="capitalize">{payment?.status}</span>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PaymentHistory;